import { Chip, ListItemButton, Tooltip } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import ArrowIcon from "src/components/general/ArrowIcon/ArrowIcon";
import { formatLargeNumber } from "src/utils/number";

interface TagFamilyHeaderProps {
  familyName: string;
  totalCount: number;
  isOpen: boolean;
  onToggle: () => void;
}

export default function TagFamilyHeader({
  familyName,
  totalCount,
  isOpen,
  onToggle,
}: TagFamilyHeaderProps) {
  return (
    <ListItemButton onClick={onToggle} className="group/arrow">
      <ListItemText
        className="font-semibold"
        slotProps={{
          primary: {
            className: "font-semibold",
          },
        }}
        primary={familyName}
      />
      <Tooltip arrow disableInteractive title={`${totalCount} tags in this family`}>
        <Chip
          size="small"
          color="info"
          sx={{ mr: 1 }}
          label={formatLargeNumber(totalCount)}
        />
      </Tooltip>
      <ArrowIcon up={isOpen} down={!isOpen} className="mr-1" />
    </ListItemButton>
  );
}
